import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["width", "height", "viewBox", "aria-labelledby", "color"]
const _hoisted_2 = ["id"]


export default /*#__PURE__*/_defineComponent({
  __name: 'IconComponent',
  props: {
  iconName: {
    type: String,
    default: 'box'
  },
  width: {
    type: [Number, String],
    default: 24
  },
  height: {
    type: [Number, String],
    default: 24
  },
  iconColor: {
    type: String,
    default: 'currentColor'
  },
  showTitle: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width,
    height: props.height,
    viewBox: `0 0 ${props.width} ${props.height}`,
    "aria-labelledby": props.iconName,
    role: "presentation",
    color: __props.iconColor
  }, [
    (__props.showTitle)
      ? (_openBlock(), _createElementBlock("title", {
          key: 0,
          id: props.iconName,
          lang: "en"
        }, _toDisplayString(props.iconName) + " icon ", 9, _hoisted_2))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 8, _hoisted_1))
}
}

})